/*
 * SINNERS – Kosárból-szerkesztés
 * Minden egyedi tervezésű kosártételhez "Tervezés szerkesztése" gombot injektál.
 * Póló ("Felirat") és hoodie ("... - Egyedi" x3) helyben, előtöltött panelben
 * szerkeszthető. Páros hoodie ("Pár hoodie") a termékoldalra visz vissza.
 */
(function () {
  var CFG = window.SINNERS_EDIT || {};
  var overlay, bodyEl, msgEl, subEl, saveBtn;
  var current = null; // { key, kind, item }
  var busy = false;

  var HOODIE_KEYS = [
    'Eleje nyakkör középen - Egyedi',
    'Háta nyakkör kapucni alatt - Egyedi',
    'Kézelő felett - Egyedi'
  ];
  var GIFT_MARKER = '_gift_hoodie';

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function applySections(sections) {
    if (!sections) { return; }
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (comp) {
      var id = comp.getAttribute('data-section-id');
      var html = sections[id];
      if (!html) return;
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-items-component[data-section-id="' + id + '"]') || doc.querySelector('cart-items-component');
        if (fresh) comp.innerHTML = fresh.innerHTML;
      } catch (e) {}
    });
    document.dispatchEvent(new CustomEvent('cart:updated'));
    setTimeout(injectTriggers, 150);
  }

  // Milyen egyedi típus ez a tétel?
  function detectKind(item) {
    var p = item.properties || {};
    if (p['Pár hoodie']) return 'couple';       // páros hoodie -> termékoldalra
    // hoodie egyedi feliratok?
    for (var i = 0; i < HOODIE_KEYS.length; i++) {
      if (p[HOODIE_KEYS[i]] != null) return 'hoodie';
    }
    if (p[GIFT_MARKER] === '1') return 'hoodie'; // ajándék hoodie (akár üres feliratokkal)
    if (p['Felirat'] != null) return 'tshirt';   // póló
    return null;
  }

  // Van-e látható (nem _ kezdetũ) vagy kezelt property?
  function isEditable(item) {
    return detectKind(item) !== null;
  }

  // gombok injektálása a kosár DOM-jába
  function injectTriggers() {
    getCart().then(function (cart) {
      var rows = document.querySelectorAll('[data-key]');
      rows.forEach(function (row) {
        var key = row.getAttribute('data-key');
        if (!key) return;
        // már van gomb?
        if (row.querySelector('.sinners-edit-trigger')) return;
        // keressük meg a tételt a kosárban a key alapján
        var item = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === key) { item = cart.items[i]; break; }
        }
        if (!item || !isEditable(item)) return;

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sinners-edit-trigger';
        btn.setAttribute('data-edit-key', key);
        btn.textContent = '✎ Tervezés szerkesztése';
        btn.addEventListener('click', function () { openEditor(key); });

        // a tétel részletei alá tesszük (a details cellába)
        var target = row.querySelector('.cart-items__details') || row;
        target.appendChild(btn);
      });
    });
  }

  function openEditor(key) {
    getCart().then(function (cart) {
      var item = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].key === key) { item = cart.items[i]; break; }
      }
      if (!item) return;
      var kind = detectKind(item);
      if (kind === 'couple') {
        // páros hoodie -> termékoldalra visszük vissza SZERKESZTÉSRE.
        // Nem veszünk ki semmit előre: a régi párost majd csak akkor cseréljük,
        // amikor a vevő a termékoldalon újra hozzáadja (így a "mégse" biztonságos).
        // Összegyűjtjük MINDKÉT párt (A és B) és átadjuk a termékoldalnak.
        goEditCouple(cart, item);
        return;
      }
      current = { key: key, kind: kind, item: item };
      buildForm(item, kind);
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
    });
  }

  // Páros hoodie szerkesztése: összegyűjtjük az A és B sort, és átadjuk a
  // termékoldalnak URL-ben. A termékoldal fejti vissza a kódokat és tölti elő,
  // majd a "kosárba" gombra cseréli a régi két sort az újra.
  function goEditCouple(cart, clickedItem) {
    // keressük meg mindkét párost (Pulcsi A és Pulcsi B)
    var pairA = null, pairB = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var p = it.properties || {};
      if (!p['Pár hoodie']) continue;
      var val = String(p['Pár hoodie']);
      if (/A$/.test(val) || /A\b/.test(val)) { if (!pairA) pairA = it; }
      if (/B$/.test(val) || /B\b/.test(val)) { if (!pairB) pairB = it; }
    }
    // ha valamiért csak egyet találunk, a kattintottat tesszük be
    if (!pairA && !pairB) { pairA = clickedItem; }

    var payload = {
      a: pairA ? { key: pairA.key, variantId: pairA.variant_id, props: pairA.properties || {} } : null,
      b: pairB ? { key: pairB.key, variantId: pairB.variant_id, props: pairB.properties || {} } : null
    };

    // átadjuk base64-json-ként az URL-ben (magyar ékezetek miatt encodeURIComponent + btoa)
    var json = JSON.stringify(payload);
    var enc;
    try {
      enc = btoa(unescape(encodeURIComponent(json)));
    } catch (e) {
      enc = encodeURIComponent(json);
    }
    var url = '/products/' + (CFG.coupleHoodieHandle || 'couple-hoodie') + '?sinners_edit=' + enc;
    window.location.href = url;
  }

  function closeEditor() {
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
    current = null;
    if (msgEl) { msgEl.hidden = true; msgEl.textContent = ''; }
  }

  // méret-legördülő HTML a megfelelő variánslistából
  function sizeSelectHtml(variants, selectedId) {
    var html = '<div class="sinners-edit-field"><label class="sinners-edit-label">Méret</label>';
    html += '<select class="sinners-edit-select" data-edit-size>';
    variants.forEach(function (v) {
      var sel = (String(v.id) === String(selectedId)) ? ' selected' : '';
      var dis = v.available ? '' : ' disabled';
      var extra = v.available ? '' : ' – Elfogyott';
      html += '<option value="' + v.id + '"' + sel + dis + '>' + v.title + extra + '</option>';
    });
    html += '</select></div>';
    return html;
  }

  // egy felirat-mező: legördülő (kész opciók + egyedi) + input, előtöltve
  function textFieldHtml(labelText, fieldId, currentValue, inspoTemplateId) {
    var v = currentValue || '';
    var html = '<div class="sinners-edit-field">';
    html += '<label class="sinners-edit-label">' + labelText + '</label>';
    html += '<select class="sinners-edit-select sinners-edit-pick" data-target="' + fieldId + '" data-inspo="' + inspoTemplateId + '">';
    html += '<option value="">— nincs / válassz —</option>';
    html += '<option value="__custom__">✍️ Egyedi szöveg</option>';
    html += '</select>';
    html += '<input id="' + fieldId + '" class="sinners-edit-input sinners-edit-value" type="text" maxlength="45" placeholder="Egyedi szöveg (max. 45 karakter)…" value="' + escapeAttr(v) + '">';
    html += '</div>';
    return html;
  }

  function escapeAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function buildForm(item, kind) {
    subEl.textContent = item.product_title || item.title || '';
    var html = '';

    if (kind === 'tshirt') {
      // póló: méret + 1 Felirat
      var tvars = (CFG.tshirtVariants && CFG.tshirtVariants[item.product_id]) || null;
      if (tvars) html += sizeSelectHtml(tvars, item.variant_id);
      html += textFieldHtml('Felirat', 'sinners-edit-felirat', (item.properties || {})['Felirat'], 'sinners-edit-tshirt-inspo');
    } else if (kind === 'hoodie') {
      // hoodie: méret + 3 felirat
      html += sizeSelectHtml(CFG.hoodieVariants || [], item.variant_id);
      var p = item.properties || {};
      html += textFieldHtml('Eleje nyakkör középen', 'sinners-edit-front', p['Eleje nyakkör középen - Egyedi'], 'sinners-edit-inspo');
      html += textFieldHtml('Háta nyakkör kapucni alatt', 'sinners-edit-back', p['Háta nyakkör kapucni alatt - Egyedi'], 'sinners-edit-inspo');
      html += textFieldHtml('Kézelő felett', 'sinners-edit-cuff', p['Kézelő felett - Egyedi'], 'sinners-edit-inspo');
    }

    bodyEl.innerHTML = html;
    wirePickers();
  }

  // legördülők feltöltése inspiráció-opciókkal + custom mező logika
  function wirePickers() {
    bodyEl.querySelectorAll('.sinners-edit-pick').forEach(function (sel) {
      var tplId = sel.getAttribute('data-inspo');
      var tpl = document.getElementById(tplId);
      if (tpl && tpl.content) {
        sel.insertAdjacentHTML('beforeend', tpl.innerHTML);
      }
      var targetId = sel.getAttribute('data-target');
      var input = document.getElementById(targetId);

      // Ha az előtöltött érték megegyezik egy opcióval, azt választjuk ki;
      // különben ha van érték, "egyedi" módban hagyjuk láthatóan.
      var curVal = input ? input.value : '';
      if (curVal) {
        var matched = false;
        for (var i = 0; i < sel.options.length; i++) {
          if (sel.options[i].value === curVal) { sel.value = curVal; matched = true; break; }
        }
        if (!matched) {
          sel.value = '__custom__';
          input.hidden = false;
        } else {
          input.hidden = true;
        }
      } else {
        sel.value = '';
        input.hidden = true;
      }

      sel.addEventListener('change', function () {
        var val = sel.value;
        if (val === '__custom__') {
          input.hidden = false; input.value = ''; input.focus();
        } else if (val) {
          input.hidden = true; input.value = val;
        } else {
          input.hidden = true; input.value = '';
        }
      });
    });
  }

  function showMsg(text, type) {
    if (!msgEl) return;
    msgEl.textContent = text;
    msgEl.className = 'sinners-edit-msg' + (type ? ' is-' + type : '');
    msgEl.hidden = false;
  }

  // A mentés: a régi sort lecseréljük az újra (méret és/vagy feliratok változhattak).
  // 1) kiolvassuk az új értékeket, 2) töröljük a régi sort (key), 3) hozzáadjuk az újat.
  function saveEdit() {
    if (busy || !current) return;
    var item = current.item;
    var kind = current.kind;

    // méret
    var sizeSel = bodyEl.querySelector('[data-edit-size]');
    var newVariantId = sizeSel ? parseInt(sizeSel.value, 10) : item.variant_id;

    // property-k összeállítása (a nem kezelt, pl. _ kezdetťeket megőrizzük)
    var props = {};
    var old = item.properties || {};
    // őrizzük meg a rejtett/kezeletlen kulcsokat (pl. _gift_hoodie)
    Object.keys(old).forEach(function (k) {
      if (k.charAt(0) === '_') props[k] = old[k];
    });

    if (kind === 'tshirt') {
      var felirat = valOf('sinners-edit-felirat');
      if (felirat) props['Felirat'] = felirat;
    } else if (kind === 'hoodie') {
      var f = valOf('sinners-edit-front');
      var b = valOf('sinners-edit-back');
      var c = valOf('sinners-edit-cuff');
      if (f) props['Eleje nyakkör középen - Egyedi'] = f;
      if (b) props['Háta nyakkör kapucni alatt - Egyedi'] = b;
      if (c) props['Kézelő felett - Egyedi'] = c;
    }

    busy = true;
    if (saveBtn) saveBtn.disabled = true;

    var sections = getCartSectionIds();
    var sectionsStr = sections.length ? sections.join(',') : null;

    // 1) töröljük a régi sort
    var removeBody = { id: current.key, quantity: 0 };
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(removeBody)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        // 2) hozzáadjuk az újat
        var addBody = { items: [{ id: newVariantId, quantity: item.quantity || 1, properties: props }] };
        if (sectionsStr) { addBody.sections = sectionsStr; addBody.sections_url = window.location.pathname; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(addBody)
        }).then(function (r) { return r.json(); });
      })
      .then(function (data) {
        busy = false;
        if (saveBtn) saveBtn.disabled = false;
        closeEditor();
        applySections(data.sections);
      })
      .catch(function () {
        busy = false;
        if (saveBtn) saveBtn.disabled = false;
        showMsg('Hiba történt a mentésnél, próbáld újra.', 'error');
      });
  }

  function valOf(id) {
    var el = document.getElementById(id);
    if (!el) return '';
    return (el.value || '').trim();
  }

  function init() {
    overlay = document.getElementById('sinners-edit-overlay');
    if (!overlay) return;
    bodyEl = overlay.querySelector('[data-edit-body]');
    msgEl = overlay.querySelector('[data-edit-msg]');
    subEl = overlay.querySelector('[data-edit-productname]');
    saveBtn = overlay.querySelector('[data-edit-save]');

    overlay.querySelectorAll('[data-edit-close], [data-edit-cancel]').forEach(function (btn) {
      btn.addEventListener('click', closeEditor);
    });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeEditor(); });
    if (saveBtn) saveBtn.addEventListener('click', saveEdit);

    // gombok injektálása + kosárváltozás után újra
    injectTriggers();
    document.addEventListener('cart:updated', function () { setTimeout(injectTriggers, 150); });

    // a téma saját frissítései után is
    var origFetch = window.fetch;
    if (origFetch && !origFetch.__sinnersEditHooked) {
      var wrapped = function () {
        var args = arguments;
        var url = (args[0] && args[0].url) ? args[0].url : args[0];
        var p = origFetch.apply(this, args);
        if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { setTimeout(injectTriggers, 500); }).catch(function(){});
        }
        return p;
      };
      wrapped.__sinnersEditHooked = true;
      // ne írjuk felül a gift-hookot: csak ha még nincs hookolva
      if (!origFetch.__sinnersHooked) window.fetch = wrapped;
      else {
        // ha a gift már hookolta, csak eseményre injektálunk
        document.addEventListener('cart:updated', function () { setTimeout(injectTriggers, 300); });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
